import React, { useEffect, useState } from "react";
import Head from "../../layouts/main-layout/head/Head";
import { GetTnCPage, useAuthCompany } from "../../services/AppServices";

const RefundPolicy = () => {
  const { companyData } = useAuthCompany();
  const [isLoading, setLoading] = useState(false);
  const [staticPageData, setStaticPageData] = useState('');

  useEffect(() => {
    setLoading(true);
    GetTnCPage().then((res) => {
      setStaticPageData(res?.data?.data)
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setLoading(false)
    });
  }, []);

  return (
    <>
      <Head title="Refund Policy" />
      
      <div className="page-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <h1 className="mb-0">Refund Policy</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {staticPageData ? (
                <div dangerouslySetInnerHTML={{ __html: staticPageData?.staticPageContent }} />
              ) : (
                <div className="terms-content">
                  <div className="terms-text mt-4">
                    <h3>{companyData?.websiteName}</h3>
                    <h4>Our Refund Policy</h4>
                    <p>
                      At {companyData?.websiteName}, we strive to ensure satisfaction with all of our services.
                      This Refund Policy outlines the conditions under which refunds may be issued.
                    </p>
                  </div>

                  <div className="terms-text">
                    <h5>1. Eligibility for Refunds</h5>
                    <p>
                      Refunds are only considered in cases where the service was not delivered as promised,
                      or in the event of technical failures on our end. All refund requests must be submitted
                      within 7 days of the original transaction.
                    </p>

                    <h5>2. Non-Refundable Items</h5>
                    <p>
                      Digital services such as downloadable products, completed consultations,
                      or custom work once delivered are non-refundable unless stated otherwise.
                    </p>

                    <h5>3. Requesting a Refund</h5>
                    <p>
                      To request a refund, please contact our support team at{" "}
                      <a href={`mailto:${companyData?.email}`}>{companyData?.email}</a> with your
                      order details and reason for the request.
                    </p>

                    <h5>4. Processing Time</h5>
                    <p>
                      Approved refunds will be credited within 5–10 business days. The credited
                      amount will be returned via the original payment method.
                    </p>
                  </div>

                  <div className="terms-text">
                    <h4>Contact Us</h4>
                    <p>
                      If you have any questions about our Refund Policy, please don't hesitate to contact us at{" "}
                      <a href={`mailto:${companyData?.email}`}>{companyData?.email}</a>.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
